// Remembers how this browser last logged in, so the login dialog can offer the same
// method again (WEB-7099). People forget which email or provider they used, log in a
// different way, and land in an empty second account.
//
// Kept in its own localStorage key rather than in redux: LOGOUT resets the persisted
// reducers, and logout is exactly when this needs to survive.

const KEY = 'bm.lastLogin'

export const LOGIN_METHODS = ['email', 'google', 'facebook', 'apple']

export const setLastLogin = (method, email) => {
  if (!LOGIN_METHODS.includes(method)) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ method, email: email || '' }))
  } catch (e) {
    // Private mode or blocked storage — the dialog just won't remember.
  }
}

export const getLastLogin = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY))
    if (value && LOGIN_METHODS.includes(value.method)) {
      return { method: value.method, email: typeof value.email === 'string' ? value.email : '' }
    }
  } catch (e) {
    // Unreadable or malformed — treat as nothing remembered.
  }
  return null
}

export const clearLastLogin = () => {
  try {
    localStorage.removeItem(KEY)
  } catch (e) {
    // Nothing to clear.
  }
}

// d•••@gmail.com — enough for the owner to recognise, on a screen others may see.
export const maskEmail = email => {
  if (!email || email.indexOf('@') < 1) return ''
  const [name, domain] = email.split('@')
  return `${name[0]}•••@${domain}`
}

// The password endpoint names the provider when an email belongs to a social account:
// "Your account was created with Google login. Please use the Google login option..."
// (BaseMapAuthService). Returns that provider, or null for any other message.
export const providerFromAuthMessage = message => {
  const match = /created with (Facebook|Google|Apple) login/i.exec(message || '')
  return match ? match[1].toLowerCase() : null
}

// superagent errors carry the response body as text; ASP.NET may send a bare string
// or a JSON-encoded one.
export const authErrorMessage = err => {
  const text = err && err.response && err.response.text
  if (!text) return ''
  try {
    const parsed = JSON.parse(text)
    return typeof parsed === 'string' ? parsed : ''
  } catch (e) {
    return text
  }
}
